/**
 * Duration options for dashboard.
 * Convert to date range for API filtering.
 */

export const DURATION_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: '2days', label: '2 days' },
  { value: '1week', label: '1 week' },
  { value: '1month', label: '1 Month' },
  { value: '6months', label: '6 Months' },
  { value: 'year', label: 'Year' },
] as const;

export type DurationValue = (typeof DURATION_OPTIONS)[number]['value'];
export const DEFAULT_DURATION: DurationValue = '1week';

/** Convert duration to { startDate, endDate } (YYYY-MM-DD). endDate = today; startDate = beginning of range. */
export function durationToDateRange(duration: DurationValue): { startDate: string; endDate: string } {
  const end = new Date();
  const endDate = end.toISOString().slice(0, 10);
  let start: Date;
  switch (duration) {
    case 'today':
      start = new Date(end);
      break;
    case '2days':
      start = new Date(end);
      start.setDate(start.getDate() - 1);
      break;
    case '1week':
      start = new Date(end);
      start.setDate(start.getDate() - 6);
      break;
    case '1month':
      start = new Date(end);
      start.setMonth(start.getMonth() - 1);
      break;
    case '6months':
      start = new Date(end);
      start.setMonth(start.getMonth() - 5);
      break;
    case 'year':
      start = new Date(end);
      start.setFullYear(start.getFullYear() - 1);
      break;
    default:
      start = new Date(end);
      start.setDate(start.getDate() - 6);
  }
  const startDate = start.toISOString().slice(0, 10);
  return { startDate, endDate };
}
